/**
 * Lijst met alle allergenen + icoontjes
 *
 */
const allergenen = {
  ei: {
    label: "Ei",
    icon_amber_50: "eggs_amber_50x50.png",
    icon_grey_50: "eggs_grey_50x50.png",
    icon_red_50: "eggs_red_50x50.png",
    icon_sushito_50: "eggs_sushito_50x50.png",
    icon_amber_100: "eggs_amber_100x100.png",
    icon_grey_100: "eggs_grey_100x100.png",
    icon_red_100: "eggs_red_100x100.png",
    icon_sushito_100: "eggs_sushito_100x100.png",
    icon_amber_200: "eggs_amber_200x200.png",
    icon_grey_200: "eggs_grey_200x200.png",
    icon_red_200: "eggs_red_200x200.png",
    icon_sushito_200: "eggs_sushito_200x200.png",
  },
  schaal: {
    label: "Schaaldieren",
    icon_amber_50: "crustacena_amber_50x50.png",
    icon_grey_50: "crustacena_grey_50x50.png",
    icon_red_50: "crustacena_red_50x50.png",
    icon_sushito_50: "crustacena_sushito_50x50.png",
    icon_amber_100: "crustacena_amber_100x100.png",
    icon_grey_100: "crustacena_grey_100x100.png",
    icon_red_100: "crustacena_red_100x100.png",
    icon_sushito_100: "crustacena_sushito_100x100.png",
    icon_amber_200: "crustacena_amber_200x200.png",
    icon_grey_200: "crustacena_grey_200x200.png",
    icon_red_200: "crustacena_red_200x200.png",
    icon_sushito_200: "crustacena_sushito_200x200.png",
  },
  gluten: {
    label: "Gluten",
    icon_amber_50: "wheat_amber_50x50.png",
    icon_grey_50: "wheat_grey_50x50.png",
    icon_red_50: "wheat_red_50x50.png",
    icon_sushito_50: "wheat_sushito_50x50.png",
    icon_amber_100: "wheat_amber_100x100.png",
    icon_grey_100: "wheat_grey_100x100.png",
    icon_red_100: "wheat_red_100x100.png",
    icon_sushito_100: "wheat_sushito_100x100.png",
    icon_amber_200: "wheat_amber_200x200.png",
    icon_grey_200: "wheat_grey_200x200.png",
    icon_red_200: "wheat_red_200x200.png",
    icon_sushito_200: "wheat_sushito_200x200.png",
  },
  vis: {
    label: "Vis",
    icon_amber_50: "fish_amber_50x50.png",
    icon_grey_50: "fish_grey_50x50.png",
    icon_red_50: "fish_red_50x50.png",
    icon_sushito_50: "fish_sushito_50x50.png",
    icon_amber_100: "fish_amber_100x100.png",
    icon_grey_100: "fish_grey_100x100.png",
    icon_red_100: "fish_red_100x100.png",
    icon_sushito_100: "fish_sushito_100x100.png",
    icon_amber_200: "fish_amber_200x200.png",
    icon_grey_200: "fish_grey_200x200.png",
    icon_red_200: "fish_red_200x200.png",
    icon_sushito_200: "fish_sushito_200x200.png",
  },
  pinda: {
    label: "Pinda",
    icon_amber_50: "peanut_amber_50x50.png",
    icon_grey_50: "peanut_grey_50x50.png",
    icon_red_50: "peanut_red_50x50.png",
    icon_sushito_50: "peanut_sushito_50x50.png",
    icon_amber_100: "peanut_amber_100x100.png",
    icon_grey_100: "peanut_grey_100x100.png",
    icon_red_100: "peanut_red_100x100.png",
    icon_sushito_100: "peanut_sushito_100x100.png",
    icon_amber_200: "peanut_amber_200x200.png",
    icon_grey_200: "peanut_grey_200x200.png",
    icon_red_200: "peanut_red_200x200.png",
    icon_sushito_200: "peanut_sushito_200x200.png",
  },
  soja: {
    label: "Soja",
    icon_amber_50: "soya_amber_50x50.png",
    icon_grey_50: "soya_grey_50x50.png",
    icon_red_50: "soya_red_50x50.png",
    icon_sushito_50: "soya_sushito_50x50.png",
    icon_amber_100: "soya_amber_100x100.png",
    icon_grey_100: "soya_grey_100x100.png",
    icon_red_100: "soya_red_100x100.png",
    icon_sushito_100: "soya_sushito_100x100.png",
    icon_amber_200: "soya_amber_200x200.png",
    icon_grey_200: "soya_grey_200x200.png",
    icon_red_200: "soya_red_200x200.png",
    icon_sushito_200: "soya_sushito_200x200.png",
  },
  melk: {
    label: "Melk",
    icon_amber_50: "milk_amber_50x50.png",
    icon_grey_50: "milk_grey_50x50.png",
    icon_red_50: "milk_red_50x50.png",
    icon_sushito_50: "milk_sushito_50x50.png",
    icon_amber_100: "milk_amber_100x100.png",
    icon_grey_100: "milk_grey_100x100.png",
    icon_red_100: "milk_red_100x100.png",
    icon_sushito_100: "milk_sushito_100x100.png",
    icon_amber_200: "milk_amber_200x200.png",
    icon_grey_200: "milk_grey_200x200.png",
    icon_red_200: "milk_red_200x200.png",
    icon_sushito_200: "milk_sushito_200x200.png",
  },
  noten: {
    label: "noten",
    icon_amber_50: "treenut_amber_50x50.png",
    icon_grey_50: "treenut_grey_50x50.png",
    icon_red_50: "treenut_red_50x50.png",
    icon_sushito_50: "treenut_sushito_50x50.png",
    icon_amber_100: "treenut_amber_100x100.png",
    icon_grey_100: "treenut_grey_100x100.png",
    icon_red_100: "treenut_red_100x100.png",
    icon_sushito_100: "treenut_sushito_100x100.png",
    icon_amber_200: "treenut_amber_200x200.png",
    icon_grey_200: "treenut_grey_200x200.png",
    icon_red_200: "treenut_red_200x200.png",
    icon_sushito_200: "treenut_sushito_200x200.png",
  },
  sesamzaad: {
    label: "Sesamzaad",
    icon_amber_50: "sesame_amber_50x50.png",
    icon_grey_50: "sesame_grey_50x50.png",
    icon_red_50: "sesame_red_50x50.png",
    icon_sushito_50: "sesame_sushito_50x50.png",
    icon_amber_100: "sesame_amber_100x100.png",
    icon_grey_100: "sesame_grey_100x100.png",
    icon_red_100: "sesame_red_100x100.png",
    icon_sushito_100: "sesame_sushito_100x100.png",
    icon_amber_200: "sesame_amber_200x200.png",
    icon_grey_200: "sesame_grey_200x200.png",
    icon_red_200: "sesame_red_200x200.png",
    icon_sushito_200: "sesame_sushito_200x200.png",
  },
  zwaveldioxide: {
    label: "Zwaveldioxide",
    icon_amber_50: "su;phurdioxide_amber_50x50.png",
    icon_grey_50: "su;phurdioxide_grey_50x50.png",
    icon_red_50: "su;phurdioxide_red_50x50.png",
    icon_sushito_50: "su;phurdioxide_sushito_50x50.png",
    icon_amber_100: "su;phurdioxide_amber_100x100.png",
    icon_grey_100: "su;phurdioxide_grey_100x100.png",
    icon_red_100: "su;phurdioxide_red_100x100.png",
    icon_sushito_100: "su;phurdioxide_sushito_100x100.png",
    icon_amber_200: "su;phurdioxide_amber_200x200.png",
    icon_grey_200: "su;phurdioxide_grey_200x200.png",
    icon_red_200: "su;phurdioxide_red_200x200.png",
    icon_sushito_200: "su;phurdioxide_sushito_200x200.png",
  },
  lupine: {
    label: "Lupine",
    icon_amber_50: "lupin_amber_50x50.png",
    icon_grey_50: "lupin_grey_50x50.png",
    icon_red_50: "lupin_red_50x50.png",
    icon_sushito_50: "lupin_sushito_50x50.png",
    icon_amber_100: "lupin_amber_100x100.png",
    icon_grey_100: "lupin_grey_100x100.png",
    icon_red_100: "lupin_red_100x100.png",
    icon_sushito_100: "lupin_sushito_100x100.png",
    icon_amber_200: "lupin_amber_200x200.png",
    icon_grey_200: "lupin_grey_200x200.png",
    icon_red_200: "lupin_red_200x200.png",
    icon_sushito_200: "lupin_sushito_200x200.png",
  },
  weekdieren: {
    label: "Weekdieren",
    icon_amber_50: "molluscs_amber_50x50.png",
    icon_grey_50: "molluscs_grey_50x50.png",
    icon_red_50: "molluscs_red_50x50.png",
    icon_sushito_50: "molluscs_sushito_50x50.png",
    icon_amber_100: "molluscs_amber_100x100.png",
    icon_grey_100: "molluscs_grey_100x100.png",
    icon_red_100: "molluscs_red_100x100.png",
    icon_sushito_100: "molluscs_sushito_100x100.png",
    icon_amber_200: "molluscs_amber_200x200.png",
    icon_grey_200: "molluscs_grey_200x200.png",
    icon_red_200: "molluscs_red_200x200.png",
    icon_sushito_200: "molluscs_sushito_200x200.png",
  },
  selderij: {
    label: "Selderij",
    icon_amber_50: "celery_amber_50x50.png",
    icon_grey_50: "celery_grey_50x50.png",
    icon_red_50: "celery_red_50x50.png",
    icon_sushito_50: "celery_sushito_50x50.png",
    icon_amber_100: "celery_amber_100x100.png",
    icon_grey_100: "celery_grey_100x100.png",
    icon_red_100: "celery_red_100x100.png",
    icon_sushito_100: "celery_sushito_100x100.png",
    icon_amber_200: "celery_amber_200x200.png",
    icon_grey_200: "celery_grey_200x200.png",
    icon_red_200: "celery_red_200x200.png",
    icon_sushito_200: "celery_sushito_200x200.png",
  },
};

export default allergenen;
